import { useState, useEffect } from 'react'
import { useAuth } from '../../context/AuthContext'
import { get, post, put, del } from '../../utils/api'
import { IconPlus, IconEdit, IconTrash, IconMap2 } from '@tabler/icons-react'

export default function CorporateRegions() {
  const { user } = useAuth()
  const [regions, setRegions] = useState([])
  const [loading, setLoading] = useState(true)
  const [editing, setEditing] = useState(null)
  const [newName, setNewName] = useState('')
  const [adding, setAdding] = useState(false)
  const [addName, setAddName] = useState('')

  const isAdmin = user?.role === 'corporate_admin'

  const load = () => get('/corporate/regions').then(setRegions).catch(console.error).finally(() => setLoading(false))
  useEffect(() => { load() }, [])

  const handleAdd = async () => {
    if (!addName.trim()) return
    try { await post('/corporate/regions', { name: addName.trim() }); setAddName(''); setAdding(false); load() } catch (err) { alert(err.message) }
  }

  const handleEdit = async (id) => {
    if (!newName.trim()) return
    try { await put(`/corporate/regions/${id}`, { name: newName.trim() }); setEditing(null); load() } catch (err) { alert(err.message) }
  }

  const handleDelete = async (id, name) => {
    if (!confirm(`Delete region "${name}"? Hotels in this region will be unassigned.`)) return
    try { await del(`/corporate/regions/${id}`); load() } catch (err) { alert(err.message) }
  }

  if (loading) return <div className="text-center py-5"><div className="spinner-border text-primary"></div></div>

  return (
    <div>
      <div className="d-flex align-items-center justify-content-between mb-4">
        <div>
          <h2 className="mb-1">Regions</h2>
          <div className="text-secondary">{regions.length} regions</div>
        </div>
        {isAdmin && !adding && (
          <button className="btn btn-primary btn-sm d-flex align-items-center gap-1" onClick={() => setAdding(true)}>
            <IconPlus size={16} /> Add Region
          </button>
        )}
      </div>

      <div className="card">
        <div className="table-responsive">
          <table className="table table-vcenter card-table">
            <thead>
              <tr>
                <th>Region</th>
                <th className="text-end">Hotels</th>
                {isAdmin && <th style={{ width: 120 }}>Actions</th>}
              </tr>
            </thead>
            <tbody>
              {adding && (
                <tr>
                  <td>
                    <div className="d-flex gap-2">
                      <input className="form-control form-control-sm" value={addName} onChange={e => setAddName(e.target.value)} placeholder="Region name" autoFocus onKeyDown={e => e.key === 'Enter' && handleAdd()} />
                      <button className="btn btn-sm btn-primary" onClick={handleAdd}>Save</button>
                      <button className="btn btn-sm btn-ghost-secondary" onClick={() => { setAdding(false); setAddName('') }}>Cancel</button>
                    </div>
                  </td>
                  <td></td>
                  {isAdmin && <td></td>}
                </tr>
              )}
              {regions.map(r => (
                <tr key={r.id}>
                  <td>
                    {editing === r.id ? (
                      <div className="d-flex gap-2">
                        <input className="form-control form-control-sm" value={newName} onChange={e => setNewName(e.target.value)} autoFocus onKeyDown={e => e.key === 'Enter' && handleEdit(r.id)} />
                        <button className="btn btn-sm btn-primary" onClick={() => handleEdit(r.id)}>Save</button>
                        <button className="btn btn-sm btn-ghost-secondary" onClick={() => setEditing(null)}>Cancel</button>
                      </div>
                    ) : (
                      <div className="d-flex align-items-center gap-2">
                        <IconMap2 size={18} className="text-blue" />
                        <span className="fw-medium">{r.name}</span>
                      </div>
                    )}
                  </td>
                  <td className="text-end">{r.hotel_count} {r.hotel_count === 1 ? 'hotel' : 'hotels'}</td>
                  {isAdmin && (
                    <td>
                      <div className="d-flex gap-1">
                        <button className="btn btn-sm btn-ghost-primary btn-icon" onClick={() => { setEditing(r.id); setNewName(r.name) }}><IconEdit size={16} /></button>
                        <button className="btn btn-sm btn-ghost-danger btn-icon" onClick={() => handleDelete(r.id, r.name)}><IconTrash size={16} /></button>
                      </div>
                    </td>
                  )}
                </tr>
              ))}
              {!regions.length && !adding && (
                <tr><td colSpan={isAdmin ? 3 : 2} className="text-center text-secondary py-4">No regions defined</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  )
}
